import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react';
import { RosadoPromo } from './RosadoPromo';
import { NegroPromo } from './NegroPromo';
const KIT_NEGRO_URL = 'https://e04whn-0h.myshopify.com/products/kit-negro-premium-para-extensiones-de-pestanas';
const KIT_ROSADO_URL = 'https://e04whn-0h.myshopify.com/products/kit-rosado-premium-para-extensiones-de-pestanas';
export function Products() {
  const [expandedRosado, setExpandedRosado] = useState(false);
  const [expandedNegro, setExpandedNegro] = useState(false);
  const [rosadoImageIndex, setRosadoImageIndex] = useState(0);
  const [negroImageIndex, setNegroImageIndex] = useState(0);
  const rosadoImages = ['https://cdn.magicpatterns.com/uploads/wq6YXJAr6hdYgGtddAmQq2/ChatGPT_Image_20_abr_2026,_20_08_07.png', 'https://cdn.magicpatterns.com/uploads/fWALG8H619iKDk6xyKSDsJ/d6f6b1d7-7906-4849-9b0b-dc5ea9cc688d.jpg', 'https://cdn.magicpatterns.com/uploads/uPfBUfT2hUtyDL8fWtXdWE/ChatGPT_Image_20_abr_2026,_20_07_24.png', 'https://cdn.magicpatterns.com/uploads/7W27e3K4woAXVtoifegPKg/4497e3b6-c0e6-4929-acb0-fe381dad099e.jpg', 'https://cdn.magicpatterns.com/uploads/8ysrASFbWq8yb2Zw8e4wVz/92520652-d6ae-41d4-a9b7-bc6974ef76e5.jpg', 'https://cdn.magicpatterns.com/uploads/wtyLJRm6gaTAuHmKCZaKjf/0D8CC461-27A2-4BAA-BC23-CABB4DFA6045.png'];
  const negroImages = ['https://cdn.magicpatterns.com/uploads/7yFwuHrde9f4MrWQZW9sUK/ChatGPT_Image_20_abr_2026,_20_08_20.png', 'https://cdn.magicpatterns.com/uploads/hrhNm58zU1nucXYAfoSFMa/ChatGPT_Image_20_abr_2026,_20_04_57.png', 'https://cdn.magicpatterns.com/uploads/xoVRRCVj4e1ur15p81n3bi/110A8423-A3E2-411B-83EE-B09C7DD1FBDA_(1).png', 'https://cdn.magicpatterns.com/uploads/tsV5i4YR5v7GKqnbdcoe2p/fa2f9a63-2c6d-44b6-aa45-3fdf25e9746a.jpg', 'https://cdn.magicpatterns.com/uploads/7Nnr2e2uuGKDNHDsGGZ61U/6e02a688-b463-4266-931d-04d88ee12b51.jpg'];
  return <section className="py-24 px-6 bg-white" id="products" data-id="element-187" data-mp="2p8lvddrb81dg">
      <div className="max-w-6xl mx-auto" data-id="element-188" data-mp="2p5zkp594h5r0">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-189" data-mp="2l7s5wfy7yeig">
          <h2 className="text-3xl md:text-4xl font-serif text-luxury-black mb-4" data-id="element-190" data-mp="26baxnxlbtg04">
            ELIGE TU FAVORITO
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-191" data-mp="1xgmqu303rq97"></div>
        </motion.div>

        <div className="flex flex-col gap-12 lg:gap-16" data-id="element-192" data-mp="1si1rs6wl7cmc">
          {/* KIT ROSADO — PROTAGONISTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="group relative bg-rosado-soft rounded-2xl p-8 md:p-12 border border-rosado-light/30 hover:shadow-xl transition-shadow duration-500 flex flex-col max-w-2xl mx-auto w-full" data-id="element-193" data-mp="1niytd5b444nc">
            <div className="absolute top-6 right-6 bg-white text-rosado font-bold text-xs tracking-wider uppercase px-3 py-1.5 rounded-full shadow-sm flex items-center gap-1 z-10" data-id="element-194" data-mp="1ncg4v8ash0gd">
              🔥 MÁS VENDIDO
            </div>

            {/* Image Gallery */}
            <div className="relative aspect-[3/2] sm:aspect-[4/3] bg-white rounded-xl mb-6 overflow-hidden -mx-2 md:-mx-4" data-id="element-195" data-mp="zndb522vrh5i">
              <a href={KIT_ROSADO_URL} target="_blank" rel="noopener noreferrer" aria-label="Comprar Kit Rosado Premium" className="block w-full h-full" data-id="element-196" data-mp="14fwpw2db0ibw">
                <img src={rosadoImages[rosadoImageIndex]} alt="Kit Rosado Premium" loading="eager" decoding="async" className="w-full h-full object-cover transition-opacity duration-300" style={{
                imageRendering: 'auto',
                WebkitBackfaceVisibility: 'hidden'
              }} data-id="element-197" data-mp="2dmynrat2fnx0" />
              </a>
              {/* Navigation arrows */}
              <button onClick={() => setRosadoImageIndex(prev => prev === 0 ? rosadoImages.length - 1 : prev - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-sm transition-colors" data-id="element-198" data-mp="2scebsj17pf90">
                <ChevronLeft className="w-4 h-4 text-luxury-black" data-id="element-199" data-mp="16z1i03d2vi9o" />
              </button>
              <button onClick={() => setRosadoImageIndex(prev => prev === rosadoImages.length - 1 ? 0 : prev + 1)} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-sm transition-colors" data-id="element-200" data-mp="3im53ro0u6t5p">
                <ChevronRight className="w-4 h-4 text-luxury-black" data-id="element-201" data-mp="2zvx094t860oz" />
              </button>
              {/* Dots */}
              <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5" data-id="element-202" data-mp="34v06utousez2">
                {rosadoImages.map((_, i) => <button key={i} onClick={() => setRosadoImageIndex(i)} className={`w-2 h-2 rounded-full transition-colors ${i === rosadoImageIndex ? 'bg-rosado' : 'bg-white/60'}`} data-id="element-203" data-mp="2pzaiiow73pr6" data-mpi={i} />)}
              </div>
            </div>

            <h3 className="text-2xl font-serif text-luxury-black mb-3" data-id="element-204" data-mp="t2tk2507o7rr">
              <a href={KIT_ROSADO_URL} target="_blank" rel="noopener noreferrer" data-id="element-205" data-mp="rpleejx8fofs">
                KIT ROSADO PREMIUM
              </a>
            </h3>
            <p className="text-gray-600 font-sans font-light mb-6" data-id="element-206" data-mp="hrx8cxu6euib">
              Elegancia, organización y estilo en un solo beauty kit diseñado
              para mujeres que aman verse profesionales siempre.
            </p>

            <ul className="space-y-2.5 mb-6" data-id="element-207" data-mp="15ff8bgnlgywd">
              {['Fácil de usar', 'Compacto y portátil', 'Ideal para citas, estudio o viajes', 'Perfecto para profesionales y principiantes', 'Diseño femenino y sofisticado', 'Acabado premium elegante'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-700" data-id="element-208" data-mp="1t6ucleyxlqa9" data-mpi={i}>
                  <Check className="w-5 h-5 text-rosado shrink-0" data-id="element-209" data-mp="371sz5io7rjfb" />
                  <span data-id="element-210" data-mp="3c047tq2rvnvy">{item}</span>
                </li>)}
            </ul>

            <p className="font-serif italic text-luxury-black text-center mb-6 text-sm" data-id="element-211" data-mp="3c1ysd3a4tdzi">
              Todo en orden. Todo contigo.
            </p>

            <a href={KIT_ROSADO_URL} target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-rosado hover:bg-rosado-light text-white font-sans font-medium tracking-widest uppercase py-4 rounded-sm transition-colors duration-300" data-id="element-212" data-mp="3l1vaem20nell">
              COMPRAR KIT ROSADO
            </a>

            <p className="text-center text-xs text-gray-400 mt-3 tracking-wide" data-id="element-213" data-mp="7lnuteo2a3in">
              ✨ Ideal para regalar
            </p>

            <button onClick={() => setExpandedRosado(!expandedRosado)} className="mt-6 flex items-center justify-center gap-2 w-full text-sm font-medium text-gray-500 hover:text-rosado transition-colors uppercase tracking-wider" data-id="element-214" data-mp="cmblfz8doicc">
              {expandedRosado ? 'Ocultar detalles' : 'Ver detalles'}
              <motion.div animate={{
              rotate: expandedRosado ? 180 : 0
            }} data-id="element-215" data-mp="3jpllwbxb5px2">
                <ChevronDown className="w-4 h-4" data-id="element-216" data-mp="3tl5i6zfsaqmc" />
              </motion.div>
            </button>

            <AnimatePresence data-id="element-217" data-mp="35v1gwyq2j2yi">
              {expandedRosado && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.4,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-218" data-mp="30wq6omvv2qfr">
                  <div className="pt-8 mt-6 border-t border-rosado-light/30" data-id="element-219" data-mp="280qqxvjnmbe5">
                    <h4 className="font-serif text-lg text-luxury-black mb-4" data-id="element-220" data-mp="2cu39bnxqplyg">
                      TU ESENCIAL DE BELLEZA, ORGANIZADO CON ESTILO
                    </h4>

                    <div className="space-y-4 text-sm text-gray-600 font-light mb-8" data-id="element-221" data-mp="232p5j3yr9zzi">
                      <p data-id="element-222" data-mp="2qst6f3kk7lmt">
                        Diseñado para mujeres que aman los detalles, la
                        organización y una imagen impecable. Este beauty travel
                        kit combina elegancia, practicidad y comodidad para
                        acompañarte a donde vayas.
                      </p>
                      <p data-id="element-223" data-mp="2lsoqbenkcsx4">
                        Ideal tanto para profesionales como para principiantes
                        que desean tener sus herramientas siempre listas y en
                        orden.
                      </p>
                    </div>

                    <div className="mb-8" data-id="element-224" data-mp="3ipsfj3p35ip6">
                      <h5 className="text-xs font-bold tracking-widest uppercase text-rosado mb-4" data-id="element-225" data-mp="3ir3g6un8iac2">
                        DETALLES DEL PRODUCTO:
                      </h5>
                      <ul className="space-y-2 pl-1" data-id="element-226" data-mp="390ih763nf3sm">
                        {['Incluye 8 esenciales beauty items', 'Tono universal', 'No sensible al calor', 'Libre de crueldad animal', 'No caduca', 'Presentación tipo estuche / kit / cosmetiquera'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-227" data-mp="2q37ne10sd2kk" data-mpi={i}>
                            <span className="w-1.5 h-1.5 rounded-full bg-rosado shrink-0 mt-1.5" data-id="element-228" data-mp="oa9mdhwuv3oj"></span>
                            <span data-id="element-229" data-mp="t81qrbeosi9m">{item}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div className="mb-8 bg-white/60 p-4 rounded-lg border border-rosado-light/20" data-id="element-230" data-mp="28saoicfa9wwo">
                      <p className="text-xs font-bold uppercase text-luxury-black mb-1" data-id="element-231" data-mp="2nh6t1zi4srsj">
                        IMPORTANTE:
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-232" data-mp="2invm7ydbkb0m">
                        Solo para uso externo.
                      </p>
                    </div>

                    <a href={KIT_ROSADO_URL} target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-luxury-black hover:bg-luxury-dark text-white font-sans font-medium tracking-widest uppercase py-4 rounded-sm transition-colors duration-300 mb-6" data-id="element-233" data-mp="2seq994ye3en4">
                      COMPRAR KIT ROSADO
                    </a>

                    <p className="text-center font-serif italic text-gray-500 text-sm" data-id="element-234" data-mp="174jdiu0v3tvn">
                      Femenino, elegante y práctico para acompañarte siempre.
                    </p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>

          {/* Rosado Promo Section */}
          <RosadoPromo data-id="element-235" data-mp="3l4pnzp5dgmyj" />

          {/* Separator */}
          <div className="flex items-center gap-4 max-w-xs mx-auto" data-id="element-236" data-mp="3l237h00i6x46">
            <div className="flex-1 h-px bg-gray-200" data-id="element-237" data-mp="3q30ze4bbf5iv"></div>
            <span className="text-xs tracking-[0.2em] uppercase text-gray-400 font-medium" data-id="element-238" data-mp="3v23sqrhxnnb0">
              o elige
            </span>
            <div className="flex-1 h-px bg-gray-200" data-id="element-239" data-mp="3p94wl6krzmu"></div>
          </div>

          {/* KIT NEGRO — ALTERNATIVA PREMIUM */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="group relative bg-luxury-black text-white rounded-2xl p-8 md:p-12 border border-luxury-dark hover:shadow-2xl transition-shadow duration-500 flex flex-col max-w-2xl mx-auto w-full" data-id="element-240" data-mp="7rnnr5a8uze4">
            <div className="absolute top-6 right-6 bg-gold text-luxury-black font-bold text-xs tracking-wider uppercase px-3 py-1.5 rounded-full shadow-sm flex items-center gap-1 z-10" data-id="element-241" data-mp="dt7pol94p8kb">
              💎 PREMIUM QUALITY
            </div>

            {/* Image Gallery */}
            <div className="relative aspect-[3/2] sm:aspect-[4/3] bg-luxury-dark/50 rounded-xl mb-6 -mx-2 md:-mx-4 overflow-hidden" data-id="element-242" data-mp="10ru9vy2ovz1m">
              <a href={KIT_NEGRO_URL} target="_blank" rel="noopener noreferrer" aria-label="Comprar Kit Negro Luxury" className="block w-full h-full" data-id="element-243" data-mp="wq8xedu2hmry">
                <img src={negroImages[negroImageIndex]} alt="Kit Negro Luxury" loading="eager" decoding="async" className="w-full h-full object-cover transition-opacity duration-300" style={{
                imageRendering: 'auto',
                WebkitBackfaceVisibility: 'hidden'
              }} data-id="element-244" data-mp="1906qjsbarxz9" />
              </a>
              <button onClick={() => setNegroImageIndex(prev => prev === 0 ? negroImages.length - 1 : prev - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-black/60 hover:bg-black/80 rounded-full flex items-center justify-center shadow-sm transition-colors" data-id="element-245" data-mp="1rqy4l768ccjz">
                <ChevronLeft className="w-4 h-4 text-white" data-id="element-246" data-mp="2anzft9qdn8wd" />
              </button>
              <button onClick={() => setNegroImageIndex(prev => prev === negroImages.length - 1 ? 0 : prev + 1)} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-black/60 hover:bg-black/80 rounded-full flex items-center justify-center shadow-sm transition-colors" data-id="element-247" data-mp="2fgsg9letbv2n">
                <ChevronRight className="w-4 h-4 text-white" data-id="element-248" data-mp="8s8moiw8qs7f" />
              </button>
              <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5" data-id="element-249" data-mp="3h8bk7vtn30i1">
                {negroImages.map((_, i) => <button key={i} onClick={() => setNegroImageIndex(i)} className={`w-2 h-2 rounded-full transition-colors ${i === negroImageIndex ? 'bg-gold' : 'bg-white/40'}`} data-id="element-250" data-mp="3cajqcw9fp4b7" data-mpi={i} />)}
              </div>
            </div>

            <h3 className="text-2xl font-serif text-white mb-3" data-id="element-251" data-mp="11geajeilcxbh">
              <a href={KIT_NEGRO_URL} target="_blank" rel="noopener noreferrer" data-id="element-252" data-mp="11g4htj65wc23">
                KIT NEGRO LUXURY
              </a>
            </h3>
            <p className="text-gray-300 font-sans font-light mb-6" data-id="element-253" data-mp="1dks143ft2er1">
              Organizado. Elegante. Profesional. El beauty kit diseñado para
              mujeres que buscan proyectar una imagen impecable, mantener todo
              en orden y llevar su estilo al siguiente nivel.
            </p>

            <ul className="space-y-2.5 mb-6" data-id="element-254" data-mp="pr04cy133ulu">
              {['Todo en su lugar y fácil acceso', 'Diseño elegante y profesional', 'Ideal para citas, trabajo o viajes', 'Herramientas esenciales incluidas', 'Compacto, práctico y funcional', 'Perfecto para profesionales y principiantes'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-255" data-mp="c1ptjlc3zekv" data-mpi={i}>
                  <Check className="w-5 h-5 text-gold shrink-0" data-id="element-256" data-mp="2paxzujmwn112" />
                  <span data-id="element-257" data-mp="2lanoergcfiet">{item}</span>
                </li>)}
            </ul>

            <p className="font-serif italic text-white text-center mb-6 text-sm" data-id="element-258" data-mp="2gbaz80201z92">
              No es solo un kit. Es la forma profesional de llevar contigo todo
              lo que necesitas.
            </p>

            <a href={KIT_NEGRO_URL} target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-gold hover:bg-gold-dark text-luxury-black font-sans font-bold tracking-widest uppercase py-4 rounded-sm transition-colors duration-300" data-id="element-259" data-mp="26cvbm726l84b">
              COMPRAR KIT NEGRO
            </a>

            <p className="text-center text-xs text-gray-400 mt-3 tracking-wide" data-id="element-260" data-mp="1sjvszw73qxsj">
              ✨ Diseñado para mujeres que quieren verse y sentirse
              profesionales en todo momento.
            </p>

            <button onClick={() => setExpandedNegro(!expandedNegro)} className="mt-6 flex items-center justify-center gap-2 w-full text-sm font-medium text-gray-400 hover:text-gold transition-colors uppercase tracking-wider" data-id="element-261" data-mp="37hqduyl4v5gn">
              {expandedNegro ? 'Ocultar detalles' : 'Ver detalles'}
              <motion.div animate={{
              rotate: expandedNegro ? 180 : 0
            }} data-id="element-262" data-mp="32hkhx67tywsr">
                <ChevronDown className="w-4 h-4" data-id="element-263" data-mp="2nrmoobv1ngwp" />
              </motion.div>
            </button>

            <AnimatePresence data-id="element-264" data-mp="2smk729e7r2m9">
              {expandedNegro && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.4,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-265" data-mp="2eu42h45nywj8">
                  <div className="pt-8 mt-6 border-t border-gray-800" data-id="element-266" data-mp="2062kj2dec1p4">
                    <h4 className="font-serif text-lg text-white mb-4" data-id="element-267" data-mp="2049are7hl1cw">
                      ELEGANCIA PROFESIONAL EN CADA DETALLE
                    </h4>

                    <div className="space-y-4 text-sm text-gray-300 font-light mb-8" data-id="element-268" data-mp="295z3cnd3u6c9">
                      <p data-id="element-269" data-mp="2568guvum2cdj">
                        Pensado para mujeres y profesionales que buscan
                        presencia, orden y sofisticación. Este kit premium
                        ofrece funcionalidad total en un diseño moderno y
                        elegante.
                      </p>
                      <p data-id="element-270" data-mp="2su82xigz9els">
                        Perfecto para quienes desean proyectar una imagen
                        profesional mientras mantienen todo organizado.
                      </p>
                    </div>

                    <div className="mb-8" data-id="element-271" data-mp="30d3fptx66dnk">
                      <h5 className="text-xs font-bold tracking-widest uppercase text-gold mb-4" data-id="element-272" data-mp="2vfk0orsndwuk">
                        DETALLES DEL PRODUCTO:
                      </h5>
                      <ul className="space-y-2 pl-1" data-id="element-273" data-mp="39d8oo8i0hk3u">
                        {['Incluye 8 esenciales cuidadosamente seleccionados', 'Organización inteligente para trabajar con mayor rapidez', 'Diseño pensado para elevar tu imagen profesional', 'Ideal para uso personal o en servicios de belleza', 'Material resistente que protege cada herramienta', 'Estuche premium con acabado elegante y duradero'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-300" data-id="element-274" data-mp="1xy3bgak9835z" data-mpi={i}>
                            <span className="w-1.5 h-1.5 rounded-full bg-gold shrink-0 mt-1.5" data-id="element-275" data-mp="1jt2uk2j2yyar"></span>
                            <span data-id="element-276" data-mp="1omozf8j05xw0">{item}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div className="mb-8 bg-luxury-dark/50 p-4 rounded-lg border border-gray-800" data-id="element-277" data-mp="1ev1bvipkh0zt">
                      <p className="text-xs font-bold uppercase text-gold mb-1" data-id="element-278" data-mp="22klwe61dc6b7">
                        IMPORTANTE:
                      </p>
                      <p className="text-sm text-gray-300" data-id="element-279" data-mp="27jgro7givnc7">
                        Solo para uso externo.
                      </p>
                    </div>

                    <a href={KIT_NEGRO_URL} target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-gold hover:bg-gold-dark text-luxury-black font-sans font-bold tracking-widest uppercase py-4 rounded-sm transition-colors duration-300 mb-6" data-id="element-280" data-mp="1xl9elzpctpfh">
                      COMPRAR KIT NEGRO
                    </a>

                    <p className="text-center font-serif italic text-gray-400 text-sm" data-id="element-281" data-mp="2jv9d2t82i93y">
                      Sofisticado, práctico y diseñado para destacar.
                    </p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>

          {/* Negro Promo Section */}
          <NegroPromo data-id="element-282" data-mp="21484ddh5az77" />
        </div>
      </div>
    </section>;
}